import { useTranslation } from 'react-i18next';
import { RUTA_IMATGES } from '../Compartido/contenidoCamprodon.js';

const VENTAJAS = [
    { icono: "ventaja-millor-preu.svg", texto: "Mejor precio garantizado" },
    { icono: "ventaja-reserva-segura.svg", texto: "Reserva segura" },
    { icono: "ventaja-confirmacio.svg", texto: "Confirmación inmediata" },
];

// Franja grisa "Avantatges de reservar al web oficial".
const Ventajas = () => {

    const { t } = useTranslation();

    return (
        <section className="position-relative bg-gray">
            <div className="c-benefits-slider d-flex-center o-container">
                <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                <ul className="c-slider list-style-none m-0 p-0">
                    {VENTAJAS.map((ventaja) => (
                        <li className="c-benefits-slider__benefit" key={ventaja.icono}>
                            <img src={RUTA_IMATGES + ventaja.icono} alt="" className="c-icon" width="22" height="24" loading="lazy" decoding="async" />
                            <div>
                                <span>{t(ventaja.texto)}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Ventajas;
